/* Whitetail Hill Chestnuts — Tree picker (whc-picker.liquid + whc-picker-strip.liquid)
   Four answers in, one built order out. Rules JSON + live product JSON come from the section. */
(function () {
  'use strict';
  var root = document.querySelector('[data-whc-picker]');
  if (!root) return;

  /* ---------- data ---------- */
  function readJSON(sel, fallback) {
    var el = root.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }
  var RULES = readJSON('[data-whc-pk-rules]', { trees: {}, states: {} });
  var PRODUCTS = readJSON('[data-whc-pk-products]', []);
  var PROT = readJSON('[data-whc-pk-protection]', { variants: [] });
  var SHIP = readJSON('[data-whc-pk-ship]', { windows: {}, states: {} });
  var SIZES = JSON.parse(root.getAttribute('data-sizes') || '{"stand":8,"plot":16,"orchard":30}');
  var FREE_SHIP = parseInt(root.getAttribute('data-free-ship'), 10) || 19900;
  var COLLECTION = root.getAttribute('data-collection');
  var result = root.querySelector('[data-whc-pk-result]');
  var S = function (k) { return result.getAttribute('data-s-' + k) || ''; };

  var STATE_NAMES = { AL: 'Alabama', AR: 'Arkansas', AZ: 'Arizona', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia', IA: 'Iowa', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', MA: 'Massachusetts', MD: 'Maryland', ME: 'Maine', MI: 'Michigan', MN: 'Minnesota', MO: 'Missouri', MS: 'Mississippi', MT: 'Montana', NC: 'North Carolina', ND: 'North Dakota', NE: 'Nebraska', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NV: 'Nevada', NY: 'New York', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VA: 'Virginia', VT: 'Vermont', WA: 'Washington', WI: 'Wisconsin', WV: 'West Virginia', WY: 'Wyoming' };
  var SEASONS = { all: { w: [0.5, 0.5] }, early: { months: [9, 10], w: [0.75, 0.25] }, late: { months: [12, 1, 2], w: [0.25, 0.75] }, year: { w: [0.5, 0.5], summer: true } };
  var SLOTS = { stand: 2, plot: 3, orchard: 4 };
  var MON = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var ORDER = [8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7];

  /* trees = products that have a rule */
  var TREES = [];
  var byHandle = {};
  PRODUCTS.forEach(function (p) {
    var r = RULES.trees[p.h];
    if (!r) return;
    var t = { handle: p.h, title: p.t, id: p.id, price: Number(p.price), available: !!p.av, qty: Number(p.qty) || 0, img: p.img, url: p.url,
      zmin: r.z[0], zmax: r.z[1], drop: r.drop || [], fc: r.fc || '', fcMin: parseInt(r.fc, 10) || 10, wet: !!r.wet, poor: !!r.poor, shade: !!r.shade, min: r.min || 1, role: r.role || 'companion', pri: r.pri || 50 };
    TREES.push(t); byHandle[t.handle] = t;
  });

  /* ---------- state ---------- */
  var A = { state: 'AL', part: 'central', site: 'open', size: 'stand', season: 'all' };
  var refreshed = false;

  /* ---------- engine ---------- */
  function zoneFit(t, cold, warm) {
    if (t.zmin <= cold && t.zmax >= warm) return 'safe';
    if (t.zmin <= warm && t.zmax >= cold) return 'marginal';
    return null;
  }
  function siteOk(t, site) {
    if (site === 'wet' && !t.wet) return false;
    if (site === 'poor' && !t.poor) return false;
    if (site === 'shade' && !t.shade) return false;
    return true;
  }
  function bucket(t) {
    var d = t.drop; if (!d.length) return 'cover';
    var late = d.some(function (m) { return m === 12 || m === 1 || m === 2; });
    var early = d.some(function (m) { return m === 8 || m === 9 || m === 10; });
    if (late && early) return 'both';
    if (late || (d.indexOf(11) >= 0 && !early)) return 'late';
    if (early) return 'early';
    return 'offseason';
  }
  function score(t, season, zf) {
    var s = 100 - t.pri * 2 - t.fcMin * 1.5;
    if (zf === 'marginal') s -= 40;
    var m = SEASONS[season].months;
    if (m) s += t.drop.filter(function (x) { return m.indexOf(x) >= 0; }).length * 4;
    return s;
  }
  function band() {
    var st = RULES.states[A.state] || [6, 8];
    var cold = st[0], warm = st[1], wide = !!st[2];
    if (wide) {
      if (A.part === 'north') warm = cold + 1;
      else if (A.part === 'south') cold = warm - 1;
      else { var mid = (cold + warm) / 2; cold = Math.floor(mid); warm = Math.ceil(mid); }
    }
    return { cold: cold, warm: warm };
  }
  function recommend() {
    var b = band(), cold = b.cold, warm = b.warm;
    var inst = [], oos = [];
    TREES.forEach(function (t) {
      if (t.role === 'cover') return;
      var zf = zoneFit(t, cold, warm);
      if (!zf || !siteOk(t, A.site)) return;
      (t.available && t.qty > 0 ? inst : oos).push({ t: t, zf: zf });
    });
    var total = SIZES[A.size] || 8, w = SEASONS[A.season].w, used = {}, plan = [], subs = [], missing = { early: [], late: [] };
    function pick(want, slotQty) {
      var pool = inst.filter(function (c) { return want.indexOf(bucket(c.t)) >= 0 && !used[c.t.handle]; });
      pool.sort(function (a, b) {
        function sc(c) { var s = score(c.t, A.season, c.zf); if (want.indexOf('early') >= 0 && bucket(c.t) === 'both') s -= 10; if (c.t.min > slotQty + 2) s -= 20; return s; }
        return sc(b) - sc(a);
      });
      return pool[0];
    }
    var slots = [['early', ['early', 'both'], w[0]], ['late', ['late', 'both'], w[1]]];
    var n = SLOTS[A.size] || 2;
    if (n >= 3) slots.push(['early2', ['early', 'both'], 0]);
    if (n >= 4) slots.push(['late2', ['late', 'both'], 0]);
    if (SEASONS[A.season].summer) slots.push(['summer', ['offseason'], 0]);
    slots.forEach(function (sl) {
      var name = sl[0], want = sl[1], weight = sl[2];
      var c = pick(want, Math.max(2, Math.round(total * (weight || 0.2))));
      if (c) {
        plan.push({ slot: name, t: c.t, zf: c.zf }); used[c.t.handle] = true;
        var better = oos.filter(function (o) { return want.indexOf(bucket(o.t)) >= 0 && o.t.pri < c.t.pri; });
        if (better.length) subs.push({ from: better[0].t, to: c.t });
      } else if (name === 'early' || name === 'late') {
        missing[name] = oos.filter(function (o) { return want.indexOf(bucket(o.t)) >= 0; }).map(function (o) { return o.t; });
      }
    });
    if (!plan.length) return { status: 'empty', cold: cold, warm: warm, missing: uniq(missing.early.concat(missing.late)), oosAll: oos.map(function (o) { return o.t; }) };
    var primary = plan.filter(function (p) { return p.slot === 'early' || p.slot === 'late'; });
    var extra = plan.filter(function (p) { return !(p.slot === 'early' || p.slot === 'late'); });
    var two = primary.length === 2;
    var perExtra = extra.length ? Math.max(2, Math.floor(total / (plan.length + 2))) : 0;
    var remaining = total - perExtra * extra.length;
    primary.forEach(function (p) { p.qty = Math.max(1, Math.round(remaining * (two ? (p.slot === 'early' ? w[0] : w[1]) : 1))); });
    extra.forEach(function (p) { p.qty = perExtra; });
    plan.forEach(function (p) {
      if (p.qty < p.t.min) { p.qty = p.t.min; p.note = S('minqty').split('[count]').join(p.qty); }
      if (p.qty > p.t.qty) { p.qty = p.t.qty; p.note = S('capped').split('[count]').join(p.qty); }
    });
    plan = plan.filter(function (p) { return p.qty > 0; });
    var trees = plan.reduce(function (a, p) { return a + p.qty; }, 0);
    var sub = plan.reduce(function (a, p) { return a + p.qty * p.t.price; }, 0);
    return { status: two ? 'ok' : 'partial', cold: cold, warm: warm, plan: plan, trees: trees, subtotal: sub, subs: subs, missing: missing };
  }
  function uniq(arr) { var seen = {}; return arr.filter(function (t) { if (seen[t.handle]) return false; seen[t.handle] = true; return true; }); }

  /* pack math for protection (cheapest combination of packs covering qty, overshoot allowed) */
  function packSize(v) { var m = /\d+/.exec(v.title || ''); return m ? parseInt(m[0], 10) : 1; }
  function cheapestCover(variants, qty) {
    var packs = (variants || []).map(function (v) { return { v: v, size: packSize(v), price: Number(v.price) }; })
      .filter(function (p) { return p.size > 0 && p.price > 0; }).sort(function (a, b) { return b.size - a.size; });
    if (!packs.length || qty < 1) return null;
    var maxSize = packs.reduce(function (m, p) { return Math.max(m, p.size); }, 0), limit = qty + maxSize;
    var best = new Array(limit + 1).fill(Infinity), pick = new Array(limit + 1).fill(null); best[0] = 0;
    for (var n = 1; n <= limit; n++) for (var i = 0; i < packs.length; i++) { var p = packs[i]; if (p.size <= n && best[n - p.size] + p.price < best[n]) { best[n] = best[n - p.size] + p.price; pick[n] = i; } }
    var target = -1; for (var t = qty; t <= limit; t++) if (best[t] < Infinity && (target < 0 || best[t] < best[target])) target = t;
    if (target < 0) return null;
    var counts = {}, cur = target; while (cur > 0) { var idx = pick[cur]; counts[idx] = (counts[idx] || 0) + 1; cur -= packs[idx].size; }
    var lines = Object.keys(counts).map(function (k) { var p = packs[k]; return { id: p.v.id, size: p.size, count: counts[k], total: p.price * counts[k] }; });
    return { lines: lines, covered: target, total: best[target] };
  }

  /* ---------- helpers ---------- */
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(tpl, map) { var out = tpl; Object.keys(map).forEach(function (k) { out = out.split('[' + k + ']').join(map[k]); }); return out; }
  function dropRange(t) { if (!t.drop.length) return ''; return fill(S('drops'), { from: MON[t.drop[0]], to: MON[t.drop[t.drop.length - 1]] }); }
  function zoneLabel(r) { return r.cold === r.warm ? String(r.cold) : r.cold + '–' + r.warm; }
  function where(r) { return fill(S('eyebrow'), { state: STATE_NAMES[A.state] || A.state, zone: zoneLabel(r) }); }
  function shipLine() {
    var k = SHIP.states[A.state], w = k && SHIP.windows[k];
    if (k === 'none') return fill(S('ship-none'), { state: STATE_NAMES[A.state] });
    return fill(S('ship'), { state: STATE_NAMES[A.state], window: w || '' }).replace(/\s{2,}/g, ' ');
  }
  function summary() {
    return [STATE_NAMES[A.state], S('site-' + A.site), S('goal-' + A.size), S('season-' + A.season)].join(' · ');
  }

  /* ---------- UI: questions ---------- */
  var body = root.querySelector('[data-whc-pk-body]'), bar = root.querySelector('[data-whc-pk-toggle]');
  var stateSel = root.querySelector('[data-whc-pk-state]'), parts = root.querySelector('[data-whc-pk-parts]');
  var stateKeys = Object.keys(STATE_NAMES).sort(function (a, b) { return STATE_NAMES[a].localeCompare(STATE_NAMES[b]); });
  function fillStates(sel, placeholder) {
    if (placeholder) { var o0 = document.createElement('option'); o0.value = ''; o0.textContent = placeholder; sel.appendChild(o0); }
    stateKeys.forEach(function (k) { var o = document.createElement('option'); o.value = k; o.textContent = STATE_NAMES[k]; sel.appendChild(o); });
  }
  fillStates(stateSel); stateSel.value = A.state;

  function setOpen(o) { body.hidden = !o; bar.setAttribute('aria-expanded', o ? 'true' : 'false'); if (o && !refreshed) refreshStock(); }
  function sync() {
    root.querySelectorAll('[data-whc-pk-sites] [data-site]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-site') === A.site ? 'true' : 'false'); });
    root.querySelectorAll('[data-whc-pk-goals] [data-size]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-size') === A.size ? 'true' : 'false'); });
    root.querySelectorAll('[data-whc-pk-seasons] [data-season]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-season') === A.season ? 'true' : 'false'); });
    root.querySelectorAll('[data-whc-pk-parts] [data-part]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-part') === A.part ? 'true' : 'false'); });
    var st = RULES.states[A.state]; parts.hidden = !(st && st[2]);
    stateSel.value = A.state;
  }
  /* timer-driven scroll: smooth-scroll and rAF are unreliable in some in-app browsers */
  function targetY(el) {
    var tabs = document.querySelector('.whc2-section--tabs');
    var off = tabs ? tabs.getBoundingClientRect().height + (parseInt(tabs.style.getPropertyValue('--whc2-sticky-top') || '0', 10) || 0) + 8 : 8;
    return el.getBoundingClientRect().top + window.pageYOffset - off;
  }
  function scrollTo(el) {
    var start = window.pageYOffset, dist = targetY(el) - start, t0 = Date.now(), dur = Math.min(600, 200 + Math.abs(dist) / 6);
    if (Math.abs(dist) < 4) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, start + dist); return; }
    var timer = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / dur), e = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
      window.scrollTo(0, start + dist * e);
      if (p >= 1) { clearInterval(timer); setTimeout(function () { window.scrollTo(0, targetY(el)); }, 60); }
    }, 16);
  }
  function openPicker() { setOpen(true); scrollTo(root); }

  bar.addEventListener('click', function () { setOpen(body.hidden); });
  stateSel.addEventListener('change', function () { A.state = stateSel.value; A.part = 'central'; sync(); });
  root.addEventListener('click', function (e) {
    var b;
    if ((b = e.target.closest('[data-whc-pk-parts] [data-part]'))) { A.part = b.getAttribute('data-part'); sync(); }
    else if ((b = e.target.closest('[data-whc-pk-sites] [data-site]'))) { A.site = b.getAttribute('data-site'); sync(); }
    else if ((b = e.target.closest('[data-whc-pk-goals] [data-size]'))) { A.size = b.getAttribute('data-size'); sync(); }
    else if ((b = e.target.closest('[data-whc-pk-seasons] [data-season]'))) { A.season = b.getAttribute('data-season'); sync(); }
    else if (e.target.closest('[data-whc-pk-go]')) { show(); }
  });

  /* entry points: strip form, and any link/button pointing at #<anchor> or carrying data-whc-pk-open */
  var anchor = root.id;
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-whc-pk-strip-form]'); if (!f) return;
    e.preventDefault();
    var sel = f.querySelector('[data-whc-pk-strip-state]');
    if (sel && sel.value) { A.state = sel.value; A.part = 'central'; sync(); }
    openPicker();
  });
  document.querySelectorAll('[data-whc-pk-strip-state]').forEach(function (sel) { if (sel.options.length <= 1) fillStates(sel); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href], [data-whc-pk-open]'); if (!a || a.closest('[data-whc-picker]')) return;
    var hash = a.getAttribute('href') || '';
    var i = hash.indexOf('#'); if (i >= 0) hash = hash.slice(i + 1); else hash = '';
    if (a.hasAttribute('data-whc-pk-open') || (hash && hash === anchor)) { e.preventDefault(); e.stopImmediatePropagation(); openPicker(); }
  }, true);
  if (location.hash === '#' + anchor) setTimeout(function () { setOpen(true); }, 300);

  /* ---------- live stock refresh ---------- */
  function refreshStock() {
    refreshed = true;
    if (!COLLECTION) return;
    fetch('/collections/' + COLLECTION + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.products) return;
        j.products.forEach(function (p) {
          var t = byHandle[p.handle]; if (!t) return;
          var av = p.variants.filter(function (v) { return v.available; });
          t.available = av.length > 0;
          if (!t.available) t.qty = 0; else if (t.qty <= 0) t.qty = 999;
          var v = av.filter(function (x) { return !/^yes/i.test(x.title); })[0] || av[0];
          if (v) { t.id = v.id; t.price = Math.round(parseFloat(v.price) * 100); }
        });
        if (!result.hidden) show();
      }).catch(function () {});
  }

  /* ---------- UI: result ---------- */
  var lastPlan = null;
  function show() {
    var r = recommend(); lastPlan = r;
    var html = '';
    if (r.status === 'empty') {
      var chips = r.missing.slice(0, 6).map(function (t) { return '<a class="whc2-pk__chip" href="' + esc(t.url) + '">' + esc(t.title) + ' <em>' + esc(S('e-notify-cta')) + '</em></a>'; }).join('');
      html = '<div class="whc2-wrap">' +
        '<div class="whc2-pk__top"><div class="whc2-eyebrow">' + esc(where(r)) + ' · ' + esc(S('site-' + A.site)) + '</div><a href="#' + anchor + '" data-whc-pk-edit>' + esc(S('edit')) + '</a></div>' +
        '<h2 class="whc2-pk__rh">' + esc(S('e-heading')) + '</h2>' +
        '<p class="whc2-pk__rp">' + esc(S('e-body')) + '</p>' +
        (chips ? '<div class="whc2-pk__box"><b>' + esc(S('e-notify')) + '</b><div class="whc2-pk__chips whc2-pk__chips--wait">' + chips + '</div></div>' : '') +
        (A.site !== 'open' ? '<div class="whc2-pk__box"><b>' + esc(S('e-drier')) + '</b><p>' + esc(fill(S('e-drier-body'), { state: STATE_NAMES[A.state] })) + '</p><button type="button" class="whc2-btn whc2-btn--out" data-whc-pk-drier>' + esc(S('e-drier-btn')) + '</button></div>' : '') +
        '<div class="whc2-pk__box whc2-pk__box--row"><div><b>' + esc(S('e-call')) + '</b><p>' + esc(S('e-call-body')) + '</p></div><a class="whc2-pk__tel" href="' + esc(S('phone-href')) + '">' + esc(root.getAttribute('data-phone')) + '</a></div>' +
        '</div>';
    } else {
      var kits = r.trees, cover = cheapestCover(PROT.variants, kits), kitTotal = cover ? cover.total : 0, total = r.subtotal + kitTotal;
      var months = []; r.plan.forEach(function (p) { p.t.drop.forEach(function (m) { if (months.indexOf(m) < 0) months.push(m); }); });
      months.sort(function (a, b) { return ORDER.indexOf(a) - ORDER.indexOf(b); });
      var intro = r.status === 'partial' ? S('intro-partial') : fill(S('intro'), { from: MON[months[0]], to: MON[months[months.length - 1]] });
      var photos = r.plan.slice(0, 2).map(function (p) { return p.t.img ? '<img src="' + esc(p.t.img) + '" alt="' + esc(p.t.title) + '" loading="lazy">' : '<div class="whc2-pk__ph"></div>'; }).join('');
      var lines = r.plan.map(function (p) {
        var tag = p.slot === 'summer' ? '<span class="whc2-pk__tag">' + esc(S('summer')) + '</span>' : p.slot.indexOf('early') === 0 ? '<span class="whc2-pk__tag whc2-pk__tag--early">' + esc(S('early')) + '</span>' : '<span class="whc2-pk__tag whc2-pk__tag--late">' + esc(S('late')) + '</span>';
        if (p.zf === 'marginal') tag += '<span class="whc2-pk__tag whc2-pk__tag--marg">' + esc(S('marginal')) + '</span>';
        var meta = [dropRange(p.t), fill(S('firstcrop'), { years: p.t.fc })].filter(Boolean).join(' · ') + (p.note ? ' · ' + esc(p.note) : '');
        return '<div class="whc2-pk__line"><span class="whc2-pk__qty">' + p.qty + '</span><div><div class="whc2-pk__name"><a href="' + esc(p.t.url) + '">' + esc(p.t.title) + '</a>' + tag + '</div><div class="whc2-pk__meta">' + meta + '</div></div><div class="whc2-pk__price">' + money(p.qty * p.t.price) + '</div></div>';
      }).join('');
      var kitLine = cover
        ? '<div class="whc2-pk__line whc2-pk__line--kit"><span class="whc2-pk__qty">' + kits + '</span><div><div class="whc2-pk__name">' + esc(S('kit-title')) + '<span class="whc2-pk__tag">' + esc(S('kit-tag')) + '</span></div><div class="whc2-pk__meta">' + esc(S('kit-desc')) + '</div></div><div class="whc2-pk__price">' + money(kitTotal) + '</div></div>'
        : '<div class="whc2-pk__line whc2-pk__line--kit"><span class="whc2-pk__qty">–</span><div><div class="whc2-pk__name">' + esc(S('kit-title')) + '</div><div class="whc2-pk__meta">' + esc(S('kit-oos')) + '</div></div><div></div></div>';
      var shipNote = total >= FREE_SHIP ? S('free') : fill(S('tofree'), { amount: money(FREE_SHIP - total) });
      var notes = '';
      ['early', 'late'].forEach(function (k) {
        var m = r.missing[k]; if (!m || !m.length) return;
        notes += '<div class="whc2-pk__note whc2-pk__note--miss">' + esc(fill(S('missing'), { when: k, list: m.slice(0, 3).map(function (t) { return t.title; }).join(', ') })) + ' <a href="' + esc(m[0].url) + '">' + esc(S('notify-link')) + '</a></div>';
      });
      /* stretch-the-season add-on: best in-stock, zone-safe, site-fitting tree not in the plan that adds months */
      var used = {}; r.plan.forEach(function (p) { used[p.t.handle] = true; });
      var ups = TREES.filter(function (t) { return !used[t.handle] && t.available && t.qty > 0 && t.role !== 'cover' && bucket(t) !== 'offseason' && siteOk(t, A.site) && zoneFit(t, r.cold, r.warm) === 'safe'; })
        .map(function (t) { return { t: t, gain: t.drop.filter(function (m) { return months.indexOf(m) < 0; }).length }; })
        .filter(function (x) { return x.gain > 0; }).sort(function (a, b) { return a.t.pri - b.t.pri || b.gain - a.gain; });
      var up = ups[0], upHtml = '';
      if (up) {
        var uq = Math.max(2, up.t.min), ucover = cheapestCover(PROT.variants, uq);
        upHtml = '<div class="whc2-pk__up"><b>' + esc(S('upsell')) + '</b><div class="whc2-pk__uprow"><div><div class="whc2-pk__name">+ ' + uq + ' <a href="' + esc(up.t.url) + '">' + esc(up.t.title) + '</a></div><div class="whc2-pk__meta">' + dropRange(up.t) + ' · ' + money(uq * up.t.price + (ucover ? ucover.total : 0)) + '</div></div><button type="button" class="whc2-btn whc2-btn--out" data-whc-pk-upsell="' + esc(up.t.handle) + '" data-qty="' + uq + '">' + esc(S('upsell-add')) + '</button></div></div>';
      }
      html = '<div class="whc2-wrap">' +
        '<div class="whc2-pk__top"><div class="whc2-eyebrow">' + esc(where(r)) + '</div><a href="#' + anchor + '" data-whc-pk-edit>' + esc(S('edit')) + '</a></div>' +
        '<h2 class="whc2-pk__rh">' + esc(r.status === 'partial' ? S('heading-partial') : S('heading')) + '</h2>' +
        '<p class="whc2-pk__rp">' + esc(intro) + '</p>' +
        '<div class="whc2-pk__card"><div class="whc2-pk__photos' + (r.plan.length < 2 ? ' whc2-pk__photos--one' : '') + '">' + photos + '</div>' + lines + kitLine +
        '<div class="whc2-pk__tot"><small>' + esc(fill(S('total'), { trees: r.trees, kits: kits })) + ' · ' + esc(shipNote) + '</small><b>' + money(total) + '</b></div></div>' +
        notes +
        '<button type="button" class="whc2-btn whc2-pk__addall" data-whc-pk-addall>' + esc(S('add')) + '</button>' +
        '<div class="whc2-pk__center">' + esc(shipLine()) + '</div>' +
        upHtml + '<div class="whc2-pk__toast" data-whc-pk-toast></div></div>';
    }
    result.innerHTML = html; result.hidden = false;
    /* fold the questions into a summary */
    setOpen(false);
    var title = root.querySelector('[data-whc-pk-title]'), sum = root.querySelector('[data-whc-pk-summary]');
    title.textContent = title.getAttribute('data-answered') || title.getAttribute('data-default');
    sum.hidden = false; sum.textContent = summary() + (S('summary-hint') ? ' — ' + S('summary-hint') : '');
    scrollTo(result);
  }

  result.addEventListener('click', function (e) {
    var b;
    if (e.target.closest('[data-whc-pk-edit]')) { e.preventDefault(); e.stopPropagation(); openPicker(); }
    else if (e.target.closest('[data-whc-pk-drier]')) { A.site = 'open'; sync(); show(); }
    else if ((b = e.target.closest('[data-whc-pk-addall]'))) { addAll(b); }
    else if ((b = e.target.closest('[data-whc-pk-upsell]'))) { addUpsell(b); }
  });

  /* ---------- cart ---------- */
  function postItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }
  function afterAdd(json, btn) {
    var item = json.items ? json.items[0] : json;
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(function () {});
  }
  function linesFor(plan, kits) {
    var items = plan.map(function (p) { return { id: p.t.id, quantity: p.qty }; });
    var cover = cheapestCover(PROT.variants, kits);
    if (cover) cover.lines.forEach(function (l) { items.push({ id: l.id, quantity: l.count }); });
    return items;
  }
  function addAll(btn) {
    if (!lastPlan || lastPlan.status === 'empty') return;
    var label = btn.textContent; btn.disabled = true; btn.textContent = S('adding');
    postItems(linesFor(lastPlan.plan, lastPlan.trees)).then(function (res) {
      btn.disabled = false;
      if (!res.ok) { toast(S('failed')); btn.textContent = label; refreshed = false; refreshStock(); return; }
      btn.textContent = S('added'); btn.classList.add('is-added'); afterAdd(res.json, btn);
      setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); }, 3000);
    }).catch(function () { btn.disabled = false; btn.textContent = label; toast(S('failed')); });
  }
  function addUpsell(btn) {
    var t = byHandle[btn.getAttribute('data-whc-pk-upsell')], q = parseInt(btn.getAttribute('data-qty'), 10) || 2; if (!t) return;
    var label = btn.textContent; btn.disabled = true; btn.textContent = S('adding');
    postItems(linesFor([{ t: t, qty: q }], q)).then(function (res) {
      btn.disabled = false;
      if (!res.ok) { btn.textContent = label; toast(S('failed')); return; }
      btn.textContent = S('added'); afterAdd(res.json, btn);
    }).catch(function () { btn.disabled = false; btn.textContent = label; });
  }
  function toast(m) { var t = result.querySelector('[data-whc-pk-toast]'); if (t) t.textContent = m; }

  sync();
})();
